import React, { useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
  const { language, setLanguage, supportedLanguages, isLoading } = useTranslation();
  const [isChanging, setIsChanging] = useState(false);

  const handleLanguageChange = async (newLang: string) => {
    setIsChanging(true);
    try {
      // Wrap in try-catch to prevent context errors
      if (setLanguage) {
        await setLanguage(newLang);
        // Trigger a custom event to notify components to re-translate
        window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: newLang } }));
      }
    } catch (error) {
      console.error('Failed to change language:', error);
      // If there's an error, still try to update localStorage directly
      try {
        localStorage.setItem('app_language', newLang);
        window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: newLang } }));
      } catch (storageError) {
        console.error('Failed to update language in localStorage:', storageError);
      }
    } finally {
      setIsChanging(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="h-4 w-4 text-muted-foreground" />
      <Select
        value={language}
        onValueChange={handleLanguageChange}
        disabled={isLoading || isChanging}
      >
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent>
          {supportedLanguages.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {(isLoading || isChanging) && (
        <span className="text-xs text-muted-foreground">Translating...</span>
      )}
    </div>
  );
}

